import React from "react";
import Image from "next/image";

import icon from "/public/images/icon.svg";
import logo from "/public/images/logo.svg";

export default function SideNavContainer({ expand, children }) {
  return (
    <div
      id="side-nav"
      className={`bg-white  min-h-screen duration-150 shrink-0 ${
        expand ? "w-[254px]" : "w-[75px]"
      }`}
    >
      <div
        className={`fixed left-0 h-screen flex flex-col px-2 overflow-x-hidden whitespace-nowrap duration-150 ${
          expand ? "w-[254px]" : "w-[75px]"
        }`}
      >
        <div className="border-b h-[4.1rem] flex items-center justify-center">
          {expand ? (
            <div className="w-36">
              <Image src={logo} alt="channel" layout="responsive" />
            </div>
          ) : (
            <div className="w-8">
              <Image src={icon} alt="channel" layout="responsive" priority />
            </div>
          )}
        </div>

        {children}
      </div>
    </div>
  );
}
